import { useState } from 'react';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

export default function ForcePasswordReset({ onComplete, onLogout }) {
  const [currentPw, setCurrentPw] = useState('');
  const [newPw, setNewPw] = useState('');
  const [confirmPw, setConfirmPw] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  async function handleSubmit(e) {
    e.preventDefault();
    setError(null);
    if (newPw !== confirmPw) { setError('New passwords do not match.'); return; }
    setSaving(true);
    try {
      const res = await fetch(`${API_BASE}/auth/change-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ currentPassword: currentPw, newPassword: newPw }),
      });
      const data = await res.json();
      if (!res.ok) { setError(data.error); setSaving(false); return; }

      const meRes = await fetch(`${API_BASE}/auth/me`, { credentials: 'same-origin' });
      if (meRes.ok) {
        const updatedUser = await meRes.json();
        onComplete(updatedUser);
      }
    } catch (err) {
      setError('Failed to change password.'); setSaving(false);
    }
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: '#f5f5f5', fontFamily: "'Inter', -apple-system, sans-serif" }}>
      <div style={{ background: '#fff', borderRadius: '12px', boxShadow: '0 2px 12px rgba(0,0,0,0.08)', padding: '48px 40px', width: '100%', maxWidth: '420px' }}>
        <img src="/cm-corp-logo.png" alt="CM Corp" style={{ width: '100px', display: 'block', margin: '0 auto 12px' }} />
        <h1 style={{ fontSize: '24px', fontWeight: 700, textAlign: 'center', margin: '0 0 4px' }}>Password Reset Required</h1>
        <p style={{ fontSize: '13px', color: '#777', textAlign: 'center', margin: '0 0 28px' }}>
          Your administrator requires you to set a new password before continuing.
        </p>

        <form onSubmit={handleSubmit}>
          {error && (
            <div style={{ background: '#fee2e2', color: '#991b1b', padding: '10px 14px', borderRadius: '6px', fontSize: '13px', marginBottom: '16px', border: '1px solid #fecaca' }}>
              {error}
            </div>
          )}

          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', fontSize: '13px', fontWeight: 600, color: '#333', marginBottom: '6px' }}>Current Password</label>
            <input type="password" value={currentPw} onChange={e => setCurrentPw(e.target.value)} required autoComplete="current-password" autoFocus
              style={{ display: 'block', width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', boxSizing: 'border-box' }} />
            <div style={{ fontSize: '11px', color: '#999', marginTop: '4px' }}>Enter the temporary password you were given.</div>
          </div>

          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', fontSize: '13px', fontWeight: 600, color: '#333', marginBottom: '6px' }}>New Password</label>
            <input type="password" value={newPw} onChange={e => setNewPw(e.target.value)} required autoComplete="new-password"
              placeholder="Min 8 chars, uppercase, lowercase, number, special"
              style={{ display: 'block', width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', boxSizing: 'border-box' }} />
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', fontSize: '13px', fontWeight: 600, color: '#333', marginBottom: '6px' }}>Confirm New Password</label>
            <input type="password" value={confirmPw} onChange={e => setConfirmPw(e.target.value)} required autoComplete="new-password"
              style={{ display: 'block', width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', boxSizing: 'border-box' }} />
          </div>

          <button type="submit" disabled={saving}
            style={{ display: 'block', width: '100%', padding: '11px', background: '#111', color: '#fff', border: 'none', borderRadius: '6px', fontSize: '14px', fontWeight: 600, cursor: saving ? 'not-allowed' : 'pointer', opacity: saving ? 0.6 : 1 }}>
            {saving ? 'Updating...' : 'Set New Password'}
          </button>
        </form>

        <button onClick={onLogout}
          style={{ display: 'block', width: '100%', marginTop: '12px', padding: '9px', background: 'none', border: '1px solid #e5e7eb', borderRadius: '6px', fontSize: '13px', color: '#777', cursor: 'pointer' }}>
          Sign Out
        </button>
      </div>
    </div>
  );
}
